<script>
import { isLogin } from '@/core/index';
import './style.css';
export default {
  name: 'GiveLike',
  data() {
    return {
      room: $$.module.data.room,
      result: [],
      timer: null,
      longTimer: null,
      praiseTimer: null,
      isLogin: false
    };
  },
  // model: {
  //   prop: "show",
  //   event: "isShow"
  // },
  props: {
    width: {
      type: Number,
      default: 46
    },
    height: {
      type: Number,
      default: 46
    }
    // show: {
    //   type: Boolean,
    //   default: false
    // }
  },
  mounted() {
    // this.timer = setInterval(() => {
    //   this.result.push(this.addPraise());
    //   if (this.result.length > 10) {
    //     // this.result.splice(-28);
    //     this.result = [];
    //     this.$emit("isShow", false);
    //   }
    // }, 300);
    document.addEventListener('touchend', this.clearLongPressTimerDocument);
    document.addEventListener('touchcancel', this.clearLongPressTimerDocument);
    isLogin()
      .then(() => {
        this.isLogin = true;
      })
      .catch(() => (this.isLogin = false));
  },
  destroyed() {
    // clearInterval(this.timer);
    document.removeEventListener('touchcancel', this.clearLongPressTimerDocument);
    document.removeEventListener('touchend', this.clearLongPressTimerDocument);
  },
  computed: {
    siteId() {
      return this.room.siteId;
    },
    isJa() {
      return this.siteId == 310106;
    }
  },
  methods: {
    // isShow() {
    //   this.$emit("isShow", !this.show);
    // },
    init() {
      if (this.result.length > 80) {
        this.result.splice(-50);
        // this.$emit("close");
      }
      this.result.push(this.addPraise());
    },
    addPraise() {
      const b = Math.floor(Math.random() * 6) + 1;
      const bl = Math.floor(Math.random() * 11) + 1;
      const chidDiv = (
        <div class={`bubble b${b} bl${bl}`} data={String(Date.now())}>
          <img src={require(`@/assets/images/zan0${Math.ceil(Math.random() * 5)}.png`)} />
        </div>
      );
      return chidDiv;
    },

    longTouchPraise() {},
    /** 长按点赞【ja】 */
    async touchstart() {
      if (this.isLogin) {
        if (!this.isJa) {
          return;
        }
        this.longTimer = setTimeout(() => {
          this.init();
          this.$emit('praise');
          this.praiseTimer = setInterval(() => {
            this.init();
            this.$emit('praise');
          }, 250);
        }, 300);
      } else {
        this.$emit('praise');
      }
    },
    /** 处理长按 */
    clearLongPressTimer() {
      console.log('press end');
      this.longTimer && clearTimeout(this.longTimer);
      this.longTimer = null;
      this.praiseTimer && clearInterval(this.praiseTimer);
      this.praiseTimer = null;
    },
    /** 处理长按 */
    clearLongPressTimerDocument() {
      console.log('clearLongPressTimerDocument');
      this.clearLongPressTimer();
    },
    async clickPraise() {
      console.log('clickPraise');
      if (this.isLogin) {
        this.init();
        this.$emit('praise');
      } else {
        this.$emit('praise');
      }
    },
    refnderLike() {
      const props = {
        on: {
          click: this.clickPraise,
          touchstart: this.touchstart,
          // touchmove: this.clearLongPressTimer,
          touchend: this.clearLongPressTimer,
          touchcancel: this.clearLongPressTimer
        },
        style: { width: `${this.width}px`, height: `${this.height}px` },
        class: 'praise_bubble',
        ref: 'likebox'
      };
      return <div {...props}>{this.result}</div>;
    }
  },
  render() {
    return this.refnderLike();
  }
};
</script>
